import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudBaseService } from '../crud.service';
import { NetellerPaymentDevice } from '../models';
import { Observable } from 'rxjs';
import { FilterObjectBuilder, FilterOperator } from '../param-builders';

@Injectable()
export class NetellerPaymentDeviceService extends CrudBaseService<NetellerPaymentDevice> {

    constructor(httpClient: HttpClient) {
        super('/payment_device/netteller', httpClient);
    }

    getByAccount(accountID: string): Observable<NetellerPaymentDevice[]> {
        const filter = new FilterObjectBuilder();
        filter.by('account', FilterOperator.eq, accountID);
        return this.filter(filter.apiFilter());
    }
}
